import React from 'react'
import '../assets/css/sub-pages.css'
import Section6 from '../pages/homepage/Section6'
// import Section3DM from '../pages/products-pages/Section3DM'
import { Helmet } from 'react-helmet'
import Section1 from '../components/features-component/Section1'
import Section2 from '../components/features-component/Section2'
// import Section3 from '../components/features-component/Section3'
import Section4 from '../components/features-component/Section4'
import Section5 from '../components/features-component/Section5'
import FeaturesSlider from '../components/features-component/FeaturesSlider'
import Faqs from '../components/features-component/Faqs'
import Feature1 from '../assets/images/fin-rec-asset/Reviews/Unified Reviews Dashboard.webp'
import Feature2 from '../assets/images/fin-rec-asset/Reviews/AI-Driven Review Insights.webp'
import Feature3 from '../assets/images/fin-rec-asset/Reviews/Smart Auto-Reply System.webp'
import Feature4 from '../assets/images/fin-rec-asset/Reviews/Sentiment & Issue Tracking.webp'
import Play_btn from './../assets/images/play_supply.svg'
import YThumb_RM from '../assets/images/review-manager-thumb.png'

const ReviewsRatingNew = () => {

    const sec1data = {
        heading: "Voosh Reviews & Ratings Manager",
        subText: "Restaurants often struggle to efficiently manage and respond to customer reviews across multiple platforms, impacting their reputation and customer retention. Voosh Reviews & Ratings Manager centralizes all your reviews from DoorDash, Uber Eats, Grubhub, Google, Yelp, and more—providing deep insights and automated responses to enhance your brand image effortlessly.",
        btnText: "Master My Reviews Now",
        btnLink: "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal",
        ytVideoID: "LPG1WT9td0E",
        thumbnail: YThumb_RM,
        thumbText: "The Future of Restaurant...",
        playBtn: Play_btn,
    }

    const s2SecHead = {
        subHead: "Why Reviews & Ratings Manager?",
        heading: "Centralize, Understand, Respond—All Automatically.",
        p1: "Consolidate All Reviews",
        p2: "AI-Powered Replies",
        p3: "Insightful Analytics",
        p4: "Effortless Management",
    }

    const s2CardContents = [
        {
            id: '01',
            title: 'Unified Reviews Dashboard',
            image: Feature1,
            Problem: 'Managing reviews across multiple platforms separately is cumbersome, ineffective, and misses crucial insights.',
            Solution: "Voosh aggregates reviews from all platforms into a single dashboard, giving clear visibility into ratings, trends, unanswered reviews, and top-performing or underperforming locations.",
            Benefits: 'Instantly understand customer feedback, simplify review management, and enhance responsiveness—all from one intuitive dashboard.',
            p1: 'Spot payout discrepancies instantly',
            p2: 'Track hidden charges and adjustments clearly',
            p3: 'Automate accounting entries',
        },
        {
            id: '02',
            title: 'AI-Driven Review Insights',
            image: Feature2,
            Problem: 'Manual analysis of reviews lacks efficiency and clarity, preventing quick action and improvement.',
            Solution: "Voosh’s advanced AI categorizes reviews by sentiment, identifies top compliments and issues, and provides store-level performance insights.",
            Benefits: 'Rapidly pinpoint key strengths and weaknesses, swiftly address recurring issues, and leverage customer compliments effectively.',
            p1: 'Identify order discrepancies in real-time',
            p2: 'Reduce manual verification processes',
            p3: 'Quickly recover lost revenue',
        },
        {
            id: '03',
            title: 'Smart Auto-Reply System',
            image: Feature3,
            Problem: 'Manual replies to every review consume significant resources, often resulting in delayed responses or generic messages.',
            Solution: "Voosh’s AI-powered auto-reply generates personalized responses automatically, mirroring the tone of your customer service team. Set up customized replies easily or choose manual responses when needed.",
            Benefits: 'Deliver timely, personalized replies to every review, strengthen customer relationships, and significantly save time and effort.',
            p1: 'Automatically detect delayed or missing deposits',
            p2: 'Streamline reconciliation processes',
            p3: 'Ensure daily cash flow accuracy',
        },
        {
            id: '04',
            title: 'Sentiment & Issue Tracking',
            image: Feature4,
            Problem: 'Identifying urgent negative reviews or key compliments manually can be challenging and time-consuming.',
            Solution: "Voosh flags review sentiment automatically, clearly marking positive and negative feedback, allowing quick prioritization and action.",
            Benefits: 'Instantly act on crucial customer feedback, manage your reputation proactively, and continuously enhance customer satisfaction.',
            p1: 'Eliminate manual journal entry',
            p2: 'Ensure precise financial records',
            p3: 'Scale effortlessly with your business',
        },
    ]

    // const sec3data ={
    //     heading: "Common Misconceptions",
    //     subHead1: "Misconception",
    //     p1: "Disputes happen between restaurants and customers.",
    //     subHead2: "Reality",
    //     p2: "Order disputes occur exclusively between restaurants and third-party delivery apps. Customers are never directly involved.",
    //     btnText: "See Why Manual Disputing is Inefficient",
    //     btnLink: "https://voosh.ai/blogs/a-step-by-step-guide-to-disputing-order-errors-on-doordash-and-ubereats",
    // }

    const sec4data = {
        heading: "Why Reputation Management Teams Choose Voosh",
        subHead1: "Enhanced Reputation",
        p1: "Quickly address customer feedback, turning insights into actions to maintain a stellar brand image.",
        subHead2: "AI Efficiency",
        p2: "Automate personalized review replies, freeing your staff to focus on essential operations.",
        subHead3: "Comprehensive Insights",
        p3: "Leverage advanced analytics to identify trends, issues, and opportunities at a glance.",
    }

    const sec5data = {
        heading: "Ready to elevate your reputation effortlessly?",
        subText: "Schedule your personalized demo and discover how Voosh Reviews & Ratings Manager turns reviews into a strategic advantage.",
        btnLink: "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal&__hstc=181257784.c6a9d1b3be4a6fd2ed9c2295680beb42.1703009108941.1746007643280.1746038291275.298&__hssc=181257784.7.1746038291275&__hsfp=1658680018",

    }

    const faq_data = [
        {
            id: '0',
            head: 'What does the Reviews & Ratings Manager do exactly?',
            body: "It centralizes review management across platforms, offering clear insights, sentiment analysis, and automated personalized replies."
        },
        {
            id: '1',
            head: "How quickly can Voosh start replying to reviews?",
            body: "Setup is quick, and personalized automated replies begin instantly, providing immediate customer engagement."
        },
        {
            id: '2',
            head: "Does Voosh integrate with all review platforms?",
            body: "Yes, Voosh seamlessly integrates with DoorDash, Uber Eats, Grubhub, Google, Yelp, and other popular platforms."
        },
        {
            id: '3',
            head: "Is my review data secure with Voosh?",
            body: "Absolutely. Voosh prioritizes stringent data security measures to keep your review information fully secure and confidential."
        }
      ]

  return (
    <div style={{ backgroundColor: '#fff' }}>
      <Helmet>
        <title>Dispute Manager: Protecting Your Restaurant's Bottom Line</title>
        <meta name='description' content="Seamlessly manage and resolve disputes to protect your restaurant's earnings with Voosh's Dispute Manager" />
        <meta name='keywords' content='Voosh Solutions, Voosh Features, Restaurant Technology, 3rd Party Marketplace Management, Data-Driven Decisions, Restaurant Operations, Restaurant Profitability' />
      </Helmet>
      <Section1 datas = {sec1data} />
      <Section2 s2Contents = {s2CardContents} datas = {s2SecHead} />
      {/* <Section3 datas = {sec3data} />
      <Section3DM /> */}
      <Section4 datas = {sec4data} />
      <Section5 datas = {sec5data} />
      <FeaturesSlider />
      <Faqs datas={faq_data} />
      <Section6 />
    </div>
  )
}

export default ReviewsRatingNew
